import { render, staticRenderFns } from "./page-form-wrapper.vue?vue&type=template&id=1fecbccd&scoped=true&"
import script from "./page-form-wrapper.vue?vue&type=script&lang=js&"
export * from "./page-form-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./page-form-wrapper.vue?vue&type=style&index=0&id=1fecbccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecbccd",
  null
  
)

export default component.exports